
export class TmShipMethodRequest {
    ShipCode: string;
}

export class TmGiftCardRequest {
    CardNumber: string;
    PIN: string 
}

export class TmPaymentRequest {
    CardType: string;
    CardNumber: string
    CardExpiryMonth: string;
    CardExpiryYear: string
    RememberCard: boolean;
    MakeDefaultCard: boolean
}

export class TmMergeCartRequest {
    CartGuid: string;
}

export class TmSelectShippingAddressRequest {
    ShippingAddressId: number;
}


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/model/request/account_cart-request.ts